import contactContent from "./content/contact.json";

export const contactMock = {
  name: "contact-us",
  layoutType: 1,
  areasList: [
    {
      id: "contact-1",
      name: "contact-content",
      componentName: "Comp:ContactPage",
      content: JSON.stringify(contactContent),
    },
  ],
};
